import { render } from "./LupaKatalaluan4.vue?vue&type=template&id=31df3da0"
import script from "./LupaKatalaluan4.vue?vue&type=script&lang=js"
export * from "./LupaKatalaluan4.vue?vue&type=script&lang=js"

import "./LupaKatalaluan4.vue?vue&type=style&index=0&id=31df3da0&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__